import { ButtonGroupProps } from 'react-multi-carousel'
import { common } from '@ocean/ui'
import { ControlGroupWrapper, Counter, Arrow } from './ControlGroup.styled'

const { Icon } = common

const ControlGroup: React.FC<ButtonGroupProps> = ({ next, previous, carouselState }) => {
  const { currentSlide = 0, totalItems = 0 } = carouselState || {}

  function handlePreviousSlide() {
    if (previous) previous()
  }

  function handleNextSlide() {
    if (next) next()
  }

  return (
    <ControlGroupWrapper className='carousel-button-group'>
      <Counter>{`${currentSlide + 1}/${totalItems}`}</Counter>
      <Arrow arrowType='previous' disabled={currentSlide === 0} onClick={handlePreviousSlide}>
        <Icon icon='arrow' />
      </Arrow>
      <Arrow arrowType='next' disabled={currentSlide === totalItems - 1} onClick={handleNextSlide}>
        <Icon icon='arrow' />
      </Arrow>
    </ControlGroupWrapper>
  )
}

export default ControlGroup
